import { FolderGit2, Link2, PlayCircle, Table, ListTodo, FileCode2, SearchCheck, ServerCog } from 'lucide-react';

export interface WorkflowTile {
  title: string;
  icon: React.ReactNode;
  description: string;
  route: string;
  isNew?: boolean;
}

export const workflowTiles: WorkflowTile[] = [
  {
    title: 'Flows',
    icon: <FolderGit2 className="h-5 w-5 text-primary" />,
    description: 'Create and manage your automation flows',
    route: '/flows'
  },
  {
    title: 'Runs',
    icon: <PlayCircle className="h-5 w-5 text-primary" />,
    description: 'View execution history and monitor performance',
    route: '/runs'
  },
  {
    title: 'Runs Search',
    icon: <SearchCheck className="h-5 w-5 text-primary" />,
    description: 'Advanced search and filter runs with powerful queries',
    route: '/runs-search',
    isNew: true
  },
  {
    title: 'Templates',
    icon: <FileCode2 className="h-5 w-5 text-primary" />,
    description: 'Browse and use pre-built workflow templates',
    route: '/templates'
  },
  {
    title: 'Connections',
    icon: <Link2 className="h-5 w-5 text-primary" />,
    description: 'Manage your integrated services and APIs',
    route: '/connections'
  },
  {
    title: 'Tables',
    icon: <Table className="h-5 w-5 text-primary" />,
    description: 'View and manage your data tables',
    route: '/tables'
  },
  {
    title: 'Todos',
    icon: <ListTodo className="h-5 w-5 text-primary" />,
    description: 'Manage your todo lists and tasks',
    route: '/todos'
  },
  // {
  //   title: 'MCP Server',
  //   icon: <ServerCog className="h-5 w-5 text-primary" />,
  //   description: 'Configure MCP server and manage tools',
  //   route: '/mcp'
  // }
];
